export default function authHeader() {
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  // const accessToken = 'Mg.oHfhTYx3iOGOOxy6qyiCSsblpKAJEFsVdgTHlhTu8Hf4iR229bcG1Md0ijGY'
  if (accessToken) {
    return { Authorization: "Bearer " + accessToken };
  } else {
    return {};
  }
}
